import React from "react";

const Hero = ({ image, title, subtitle }) => {
    // Cherche si le titre finit par un point et le sépare
    const match = typeof title === "string" ? title.match(/^(.*?)(\.)$/) : null;

    // Responsive image height
    // - 700px for xl (≥1280px)
    // - 400px for md (≥768px)
    // - 250px for mobile
    // Bande verte : hauteur fixe par padding (py-10 = 2.5rem*2 = 5rem ≈ 80px)

    return (
        <div className="relative w-full">
            {/* Image section */}
            <div
                className="w-full"
                style={{
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                <img
                    src={image}
                    alt={typeof title === "string" ? title : ""}
                    className="
                        w-full
                        h-[250px]
                        md:h-[400px]
                        xl:h-[700px]
                        object-cover
                        block
                        transition-all
                        duration-300
                    "
                    style={{
                        display: "block",
                        width: "100%",
                        objectFit: "cover",
                        objectPosition: "center bottom",
                    }}
                />
                {/* Bande verte superposée, fixe en bas et hors de l'image */}
                <div
                    className="absolute left-0 right-0"
                    style={{
                        bottom: "-25px",
                        width: "100%",
                        zIndex: 2,
                    }}
                >
                    <div className="w-full bg-greenprimary py-10">
                        <div className="container mx-auto px-4">
                            <h1 className="text-white text-center text-2xl md:text-5xl font-semibold tracking-tighter">
                                {match ? (
                                    <>
                                        {match[1]}
                                        <span className="text-danger">{match[2]}</span>
                                    </>
                                ) : (
                                    title
                                )}
                            </h1>
                            {/* Toujours réserver l'espace du sous-titre (invisible si non présent) */}
                            <p
                                className={`text-white text-center text-sm md:text-lg mt-2 max-w-4xl mx-auto${subtitle ? "" : " invisible"}`}
                                style={{ minHeight: "1.75rem" }} // 1.75rem ≈ ligne de texte md:text-lg
                            >
                                {subtitle || ""}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;